import { Dock, PageScroll } from "@Components/Page";
import { WorkflowTree } from "@Components/Workflows/Components/WorkflowTree";
import { WorkflowWrapper } from "@Components/Workflows/Components/WorkflowWrapper";
import { useConnectionTree } from "@Hooks/connections/useTreeData";
import { useUserContext } from "@Hooks/contexts/useUserContext";
import { Banner, Button, CheckIcon, PageTitle, TimelineIcon } from "@UI";
import { EMPTY_TIMELINE_ERROR, insertTimeline } from "@Utils/doc/InsertTimeline";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
export function TimelineImport({ onExit }) {
    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = React.useState(false);
    const [result, setResult] = React.useState(null);
    const token = useUserContext((s)=>s?.user?.meta?.access_token.token);
    const tree = useConnectionTree({
        token,
        type: "timelines"
    });
    const onRunWorkflow = useCallback(async ()=>{
        if (!token) return;
        setIsLoading(true);
        setResult(null);
        try {
            await insertTimeline({
                id: tree.selectedId,
                token,
                headers: [
                    "title",
                    "description",
                    "date",
                    "documents",
                    "persons"
                ].map((column)=>t(`workflows.TimelineImport.columns.${column}`)),
                locale: i18n.language
            });
            setResult({
                id: tree.selectedId,
                status: "done"
            });
        } catch (error) {
            const isEmpty = error instanceof Error && error.message === EMPTY_TIMELINE_ERROR;
            if (!isEmpty) console.error("Timeline import failed:", error);
            setResult({
                id: tree.selectedId,
                status: isEmpty ? "empty" : "error"
            });
        } finally{
            setIsLoading(false);
        }
    }, [
        token,
        tree.selectedId,
        t,
        i18n.language
    ]);
    const status = result?.id === tree.selectedId ? result.status : null;
    return /*#__PURE__*/ React.createElement(WorkflowWrapper, {
        onBack: onExit
    }, /*#__PURE__*/ React.createElement(PageScroll, null, /*#__PURE__*/ React.createElement(PageTitle, {
        title: t("workflows.TimelineImport.title"),
        lede: t("workflows.TimelineImport.lede")
    }), /*#__PURE__*/ React.createElement(WorkflowTree, {
        tree: tree,
        label: t("workflows.TimelineImport.title"),
        searchPlaceholder: t("workflows.TimelineImport.search"),
        emptyIcon: TimelineIcon,
        emptyTitle: t("workflows.TimelineImport.noItemsTitle"),
        emptyText: t("workflows.TimelineImport.noItemsMessage")
    })), !tree.showNoItemsMessage && !tree.hasError && /*#__PURE__*/ React.createElement(Dock, null, status === "error" && /*#__PURE__*/ React.createElement(Banner, {
        tone: "error"
    }, t("workflows.TimelineImport.failed")), status === "empty" && /*#__PURE__*/ React.createElement(Banner, {
        tone: "info"
    }, t("workflows.TimelineImport.empty")), status === "done" && /*#__PURE__*/ React.createElement(Banner, {
        icon: /*#__PURE__*/ React.createElement(CheckIcon, null)
    }, t("workflows.TimelineImport.done")), /*#__PURE__*/ React.createElement(Button, {
        size: "lg",
        disabled: !tree.selectedItem,
        loading: isLoading,
        onClick: onRunWorkflow
    }, t("workflows.TimelineImport.insert"))));
}
